<template>
  <div>
    <!-- Componen mensajes de informacion -->

    <alertaMensaje :snackbar="mostrarSnackbar" :mensajeAlertaData="mensajeAlerta" @update-snackbar="hideSnackbar">
    </alertaMensaje>

    <confirmButton :dialogConfirm="mostrarDialogConfirm" :mensajeDialogData="mensajeDialog"
      @update-dialog="confirmDelete" @open-dialog="mostrarDialogConfirm = $event"></confirmButton>

    <!-- MODAL DE CONFIRMACION PARA ELIMINAR, -->
    <v-dialog v-model="dialog_delete" width="550">
      <v-card>
        <v-card-title class="btn_eliminar">
          <label>Eliminar pregunta</label>
          <v-spacer></v-spacer>
          <v-btn fab dark x-small class="btn_style3" @click="dialog_delete = false"><v-icon
              dark>fa-times</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="text-center black--text pt-8">
          <h3>¿Está seguro de eliminar los datos seleccionados?</h3>
          <!-- <div class="py-6">
              <div class="yellow py-2 px-3  rounded-pill mx-3" style="font-size:1rem">
              <span >{{ desc_delete }}</span>
              </div>
            </div> -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_block_style2" dark @click="confirmDelete(true)">Sí</v-btn>
          <v-btn class="btn_style3" dark @click="dialog_delete = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- @update-dialog="validaEliminarData" -->

    <!-- Compoenente mensajes de confirmacion-->
    <mensajeSistema></mensajeSistema>

    <v-container class="pa-4">
      <!-- CONTENEDOR 0 VISTA BANCO DE PREGUNTAS -->

      <v-row>
        <v-col cols="2" class="mt-1">

          <reset-button :mostrarBtnReset="contenedor_selectores" @resetearSelectores="resetSelects"></reset-button>

          <v-btn v-if="contenedor1" @click="changeView('contenedor0', idclase, null)" small depressed color="error">
            Volver
          </v-btn>
        </v-col>

        <v-col cols="10" class="text-end" v-if="contenedor0">
          <v-btn color="primary" :loading="loadingtemas" :disabled="loadingtemas"
            @click="changeView('contenedor1', idclase, null)">
            CREAR PREGUNTAS
          </v-btn>

          <v-btn class="ml-2" depressed color="error" @click="eliminarBalotarioDeactivate()">
            Eliminar
          </v-btn>
        </v-col>

        <template v-if="contenedor_selectores">
          <!-- SELECTORES GLOBALES -->

          <v-col cols="2">
            <AutocompleteComp @change="selectorPaises(obtenerIdPais)" v-model="obtenerIdPais" textLabel="País"
              :items="itemsPaises" item-value="id" item-text="nombre_pais" />
          </v-col>

          <v-col cols="2">
            <AutocompleteComp @change="selectorNiveles(obtenerNivel)" v-model="obtenerNivel" textLabel="Nivel"
              :items="itemsNiveles" item-value="id" item-text="desc_nivel" :disabled="disabledNivel" />
          </v-col>

          <v-col cols="2">
            <AutocompleteComp @change="selectorGrados(obtenerGrado)" v-model="obtenerGrado" textLabel="Grado"
              :items="itemsGrados" item-value="id" item-text="desc_grado" :disabled="disabledGrado" />
          </v-col>

          <v-col cols="2">
            <AutocompleteComp @change="selectorAreas(obtenerArea)" v-model="obtenerArea" textLabel="Área"
              :items="itemsAreas" item-value="id" item-text="desc_area" :disabled="disabledArea" />
          </v-col>

          <v-col cols="2">
            <AutocompleteComp @change="selectorCursos(obtenerCurso)" v-model="obtenerCurso" textLabel="Curso"
              :items="itemsCursos" item-value="id" item-text="desc_curso" :disabled="disabledCurso" />
          </v-col>
        </template>

        <!-- INPUT DE BUSQUEDA -->
        <template>
          <v-col cols="12" class="pt-0" v-if="contenedor0">
            <v-row class="d-flex justify-end">
              <v-col cols="3">
                <v-text-field v-model="searchQtPreguntas" append-icon="mdi-magnify" label="Búsqueda" single-line
                  hide-details></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </template>

        <!-- TABLA DE PREGUNTAS -->
        <v-col cols="12" v-if="contenedor0">
          <v-data-table :search="searchQtPreguntas" :headers="headersPrincipal" :items="arraydataUnidad"
            sort-by="unidad" class="elevation-1" show-select @toggle-select-all="selecionaTodos">
            <template v-slot:[`header.data-table-select`]="{ props, on }">
              <v-btn class="pl-0" plain small color="dark">
                <v-simple-checkbox :value="props.value" v-on="on" />

                <!-- <v-icon>mdi-arrow-down-thick</v-icon> -->

                <span>Selecciona</span>
              </v-btn>
            </template>

            <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
              <v-simple-checkbox :value="isSelected"
                @input="select($event), seleccionIndividual($event, item, isSelected, select)">
              </v-simple-checkbox>
            </template>

            <template v-slot:[`item.cantidad`]="{ item }">
              <strong>{{ item.cantidad }}</strong>
            </template>

            <template v-slot:[`item.fecha`]="{ item }">
              {{ formatearFecha(item.fecha) }}
              <!-- Se le fomratea la fecha en un formato más comodo -->
            </template>

            <template v-slot:[`item.accion_ver`]="{ item }">
              <v-tooltip bottom color="#1b1b1b">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="btn_ver px-0 mx-0" fab x-small @click="changeView('contenedor2', null, item)">
                    <v-icon>fa-eye</v-icon>
                  </v-btn>
                </template>
                <span>VER PREGUNTAS</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>

        <!-- PROGRESS BAR LOADER -->
        <v-dialog v-model="loadingSpiner.estado" :width="loadingSpiner.ancho">
          <v-card :color="loadingSpiner.colorDialog" dark>
            <v-card-text class="pt-2 text-center">
              {{ loadingSpiner.titulo }}
              <v-progress-linear indeterminate :color="loadingSpiner.color" class="mb-0">
              </v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>

      <!-- CONTENEDOR 1 (LISTA DE TEMAS - CLASES) -->
      <!-- <v-expand-transition> -->
      <v-row v-if="contenedor1">
        <v-col cols="6">
          <v-alert class="mb-0" color="amber" border="left" dense elevation="2" colored-border icon="mdi-check">
            <strong>LISTA DE CLASES</strong>
          </v-alert>
        </v-col>
        <v-col cols="3" offset="3">
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Búsqueda" single-line
            hide-details></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-sheet color="grey" class="" v-if="readyloadTemas">
            <v-skeleton-loader class="mx-auto" type="table-thead, table-row-divider@3, table-tfoot"></v-skeleton-loader>
          </v-sheet>
          <v-data-table v-else ref="table" :headers="headersUnidad" :search="search" :items="vis_tema"
            :items-per-page="itemsPerPageTemas" group-by="nombre_tema" sort-by="nombre_tema" :expanded.sync="expanded"
            :footer-props="footerProps" @update:options="actualizarVtable">
            <template v-slot:group.header="{ group, headers, toggle, isOpen }">
              <td :colspan="headers.length">
                <v-btn @click="toggle" small icon :ref="group" :data-open="isOpen">
                  <v-icon color="primary" size="30" v-if="isOpen">mdi-chevron-up</v-icon>
                  <v-icon color="primary" size="30" v-else>mdi-chevron-down</v-icon>
                </v-btn>
                <strong> UNIDAD:&nbsp;&nbsp; </strong> {{ group }}
              </td>
            </template>

            <template v-slot:[`item.accion_preguntar`]="{ item }">
              <template>
                <v-btn depressed color="primary" small @click="changeView('contenedor2', item.id_clase, item)">
                  <v-icon left> mdi-comment-question-outline </v-icon>

                  <span> BANCO DE PREGUNTAS </span>
                </v-btn>
              </template>
            </template>
            <template v-slot:[`item.accion_ver`]="{ item }">
              <v-tooltip bottom color="#1b1b1b">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="btn_ver px-0 mx-0" fab x-small
                    @click="changeView('contenedor4', item.id_clase, null)">
                    <v-icon>fa-eye</v-icon>
                  </v-btn>
                </template>
                <span>VER PREGUNTAS</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <!-- </v-expand-transition> -->

      <!-- CONTENEDOR 2 (PREGUNTAS POR CLASE ) -->
      <!-- <v-expand-transition>objetoReplicaTemas -->
      <v-row v-if="contenedor2">
        <v-col cols="12">
          <v-btn @click="changeView('contenedor0', idclase, null)" small depressed color="error">
            <v-icon size="12"> mdi-arrow-left </v-icon> Volver
          </v-btn>

          <!-- <v-btn @click="test1()" small depressed color="warning">
              <v-icon size="12"> mdi-arrow-left </v-icon> test
            </v-btn> -->
        </v-col>
        <v-col cols="2">
          <v-text-field readonly primary v-model="select_nivel" label="NIVEL" type="text"></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field readonly primary v-model="select_grado" label="GRADO" type="text"></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field readonly primary v-model="select_area" label="ÁREA" type="text"></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field readonly primary v-model="select_curso" label="CURSO" type="text"></v-text-field>
        </v-col>

        <v-col cols="6">
          <v-alert border="left" color="primary" dense shaped type="success">{{
            nombre_unidad
          }}</v-alert>
        </v-col>
        <v-col cols="6" class="text-end">
          <v-btn @click="changeView('contenedor3', idclase, null)" rounded color="primary">
            <v-icon left> mdi-plus </v-icon>
            Crear pregunta
          </v-btn>
          <v-btn class="ml-2" @click="changeView('contenedor4', idclase, null)" rounded color="success">
            <v-icon left> mdi-content-paste </v-icon>
            Ver preguntas
          </v-btn>
          <v-btn class="ml-2" rounded color="error" @click="eliminarPreguntaDeactivate()">
            <v-icon left> mdi-delete </v-icon>

            Eliminar
          </v-btn>
        </v-col>
        <v-col cols="12">
          <!-- v-sortable -->
          <v-data-table :items-per-page="siezPerPage" :search="searchPreguntas" :headers="headerPregunta"
            :items="arrayPreguntasClase" v-sortable :page.sync="page" hide-default-footer
            @sorted="cambiarOrden($event, idclase)" show-select sort-by="nombre_tema" item-key="idpregunta"
            class="elevation-1" @toggle-select-all="selecionaTodosPregunta" @page-count="pageCount = $event"
            @pagination="getPagination">
            <template v-slot:[`header.data-table-select`]="{ props, on }">
              <v-btn class="pl-0" plain small color="dark">
                <v-simple-checkbox :value="props.value" v-on="on" />

                <!-- <v-icon>mdi-arrow-down-thick</v-icon> -->

                <!-- <span>Selecciona</span> -->
              </v-btn>
            </template>

            <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
              <v-simple-checkbox color="red" :value="isSelected" @input="
                select($event),
                seleccionIndividualPregunta(
                  $event,

                  item,

                  isSelected,

                  select
                )
                ">
              </v-simple-checkbox>
            </template>
            <!-- d-none -->
            <template v-slot:[`header.idpregunta`]="{ header }">
              <div class="">
                {{ header.idpregunta }}
              </div>
            </template>
            <!-- d-none -->
            <template v-slot:[`item.idpregunta`]="{ item }">
              <div class="" style="color: #00000000">
                {{ item.idpregunta }}
              </div>
            </template>

            <template v-slot:[`item.titulo`]="{ item }">
              <p class="pt-2" v-html="item.titulo"></p>
            </template>

            <template v-slot:[`item.dificultad`]="{ item }">
              <v-chip v-if="item.dificultad == 0" color="success" class="ml-0 mr-2 black--text" label small>
                BAJA
              </v-chip>

              <v-chip v-if="item.dificultad == 1" color="blue" text-color="white" class="ml-0 mr-2 black--text" label
                small>
                MEDIA
              </v-chip>

              <v-chip v-if="item.dificultad == 2" color="red" class="ml-0 mr-2 black--text" label small>
                ALTA
              </v-chip>
            </template>

            <template v-slot:[`item.tipo`]="{ item }">
              <span class="font-weight-medium" v-if="item.tipo == 'res_uni'">
                Respuesta única
              </span>

              <span class="font-weight-medium" v-if="item.tipo == 'res_mul'">
                Respuesta múltiple
              </span>

              <span class="font-weight-medium" v-if="item.tipo == 'ver_fal'">
                Verdadero o falso
              </span>
            </template>

            <template v-slot:[`item.orden`]="{ item }">
              <strong>{{ item.orden }}</strong>
            </template>

            <template v-slot:[`item.ver`]="{ item }">
              <v-tooltip bottom color="#1b1b1b">
                <template v-slot:activator="{ on }">
                  <v-btn :loading="loading[item.idpregunta]" :disabled="loading[item.idpregunta]" v-on="on"
                    class="btn_editar px-0 mx-0" fab x-small @click="changeView('contenedor3', idclase, item)">
                    <v-icon>fa-pencil-alt</v-icon>
                  </v-btn>
                </template>
                <span>EDITAR</span>
              </v-tooltip>
            </template>
          </v-data-table>

          <v-row>
            <v-col cols="2">
              <v-select class="ml-4 pt-6" v-model="siezPerPage" :items="itemsPerPage" label="Ítems por página"
                @change="siezPerPage = parseInt($event, 10)">
              </v-select>
            </v-col>
            <v-col cols="10">
              <div class="d-flex justify-end pt-2">
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- </v-expand-transition> -->

      <!-- CONTENEDOR 3 (VISTA EDICION Y CREACION DE PREGUNTAS) FORMULARIO -->
      <!-- <v-expand-transition> -->
      <v-row v-if="contenedor3">
        <v-col cols="2" align-self="center">
          <v-btn @click="changeView('contenedor2', idclase, objetoReplicaTemas)" small depressed color="error">
            <v-icon size="12"> mdi-arrow-left </v-icon> Volver
          </v-btn>
        </v-col>
        <v-col cols="10">
          <v-row class="d-flex justify-end">
            <v-col cols="2">
              <v-text-field dense readonly v-model="select_nivel" label="NIVEL" type="text"></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field dense prepend-icon="mdi-arrow-right-bold" readonly v-model="select_grado" label="GRADO"
                type="text"></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field dense prepend-icon="mdi-arrow-right-bold" readonly v-model="select_area" label="ÁREA"
                type="text"></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field dense prepend-icon="mdi-arrow-right-bold" readonly v-model="select_curso" label="CURSO"
                type="text"></v-text-field>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" class="py-0">
          <div class="mx-5 px-5">
            <v-container fluid>
              <v-row>
                <v-col cols="6" class="d-flex align-end">
                  <v-radio-group v-model="dificultadCheckbox" label="Dificultad:" class="mt-0" hide-details>
                    <div class="d-flex">
                      <v-radio color="green" value="0" class="mr-3">
                        <template v-slot:label>
                          <strong class="success--text">Baja</strong>
                        </template>
                      </v-radio>
                      <v-radio color="blue" value="1" class="mr-3">
                        <template v-slot:label>
                          <strong class="primary--text">Media</strong>
                        </template>
                      </v-radio>
                      <v-radio color="red" value="2" class="mr-3">
                        <template v-slot:label>
                          <strong class="error--text">Alta</strong>
                        </template>
                      </v-radio>
                      <v-radio class="d-none"></v-radio>
                    </div>
                  </v-radio-group>
                </v-col>

                <v-col cols="6" class="d-flex align-end">
                  <v-select v-model="tipo_pregunta" @change="cambiarTipoRespuesta(tipo_pregunta)"
                    :items="itemTiposPreguntas" label="Seleccionar tipo de pregunta" chips :hint="tipo_pregunta.text"
                    persistent-hint></v-select>
                </v-col>

                <v-col cols="12" class="py-0">
                  <v-alert border="left" dense color="primary" dark elevation="10">
                    <div>
                      <h2 class="pa-0">INICIO SIMULADOR</h2>
                      <div class="d-flex align-center pb-2">
                        <span>{{ tituloClase }}</span>
                        <v-spacer></v-spacer>
                        <v-btn @click="abrirTextareaPregunta" dark small color="orange">
                          <v-icon dark class="pr-1">
                            {{ doingPregunta ? ' mdi-check' : 'mdi-pencil' }}
                          </v-icon>
                          {{ doingPregunta ? 'Guardar pregunta' : 'Editar pregunta' }}
                        </v-btn>
                      </div>
                    </div>
                  </v-alert>
                </v-col>
                <v-col cols="12" v-if="doingPregunta" class="py-0 my-0 text-center">

                  <ckeditor @input="validaTextAreaPregunta" ref="editor" tag-name="textarea" v-model="textarea_pregunta"
                    :config="editorConfig"></ckeditor>


                </v-col>
                <v-col v-if="preguntaHecha" cols="12">
                  <div class="pa-4" style="background: #eaeaea; text-align: center">
                    <h2 v-html="textarea_pregunta"></h2>
                  </div>
                </v-col>

                <v-col cols="12" class="">
                  <div>
                    <v-alert border="left" dense color="success" outlined dark elevation="10">
                      <div>
                        <h2 class="pa-0">IMPLEMENTA TUS RESPUESTAS</h2>
                        <v-spacer></v-spacer>

                        <div class="d-flex align-center pb-2">
                          <span> </span>

                          <!-- <h5>Implementa tus preguntas</h5> -->
                          <v-spacer></v-spacer>
                          <template v-if="doingRespuesta">
                            <v-btn @click="agregarRespuesta(textarea_respuesta)" dark small color="orange"
                              :disabled="rptaDisabled">
                              <v-icon dark class="pr-1">mdi mdi-plus</v-icon>
                              Guardar respuesta
                            </v-btn>
                          </template>
                          <template v-else>
                            <v-btn @click="abrirTextareaRespuesta" dark small color="success" :disabled="rptaDisabled">
                              <v-icon dark class="pr-1">mdi-pencil</v-icon>
                              Escribir respuesta
                            </v-btn>
                          </template>
                        </div>

                        <!-- <v-btn
                          @click="abrirTextareaRespuesta"
                          :disabled="rptaDisabled"
                          class="mx-2"
                          fab
                          dark
                          x-small
                          color="success"
                        >
                          <v-icon dark>
                            {{ doingRespuesta ? " mdi-check" : "mdi-pencil" }}
                          </v-icon>
                        </v-btn> -->
                        <!-- <v-btn class="mx-2" fab dark x-small color="light-blue darken-4">
                          <v-icon dark> mdi-format-paint </v-icon>
                        </v-btn> -->
                      </div>
                    </v-alert>
                  </div>
                </v-col>
                <!-- autofocus -->
                <v-col cols="12" v-if="doingRespuesta" class="py-0 my-0 text-center">


                  <ckeditor @input="validaTextAreaRespuesta" tag-name="textarea" v-model="textarea_respuesta"
                    :config="editorConfigRspta"></ckeditor>


                  <v-textarea style="visibility: hidden; position: absolute;" @keydown.enter.exact.prevent
                    @keyup.enter.exact="agregarRespuesta(textarea_respuesta)"
                    @keydown.enter.shift.exact="nuevaLineaTxArea" @keyup="validaTextAreaRespuesta" ref="textareaResp"
                    color="green darken-3" v-model="textarea_respuesta" filled auto-grow label="Escribe tu respuesta"
                    rows="3" row-height="20" :disabled="rptaDisabled"></v-textarea>
                  <!-- <v-btn
                    v-show="btnAgregaRespuesta"
                    @click="agregarRespuesta(textarea_respuesta)"
                    depressed
                    color="primary"
                    small
                  >
                    {{ tituloBotonAgregaEdita }}
                    <v-icon> mdi-plus </v-icon>
                  </v-btn> -->
                </v-col>

                <v-col v-show="coleccionRespuestas.lenght" cols="9" class="py-0">
                  <div>
                    <h5>Respuestas:</h5>
                  </div>
                </v-col>

                <v-col v-show="coleccionRespuestas.lenght" cols="3" align="center" class="py-0">
                  <div>
                    <h5 v-if="tipo_pregunta == 'res_uni'" class="ml-10">Selección Única:</h5>
                    <h5 v-if="tipo_pregunta == 'res_mul'" class="ml-10">Selección Múltiple:</h5>
                    <h5 v-if="tipo_pregunta == 'ver_fal'" class="ml-0">Selección V / F:</h5>
                  </div>
                </v-col>

                <v-col cols="12">
                  <!-- RESPUESTAS DINAMICAS LOOP O BLUCE FOREACH -->
                  <v-alert v-for="(respta, i) in coleccionRespuestas" :key="i" :type="coloresValidos[i] || 'error'"
                    prominent outlined dense>
                    <v-row align="center">
                      <v-col class="grow" v-html="respta">

                      </v-col>
                      <v-col class="shrink d-flex">
                        <!-- RESPUESTA UNICA -->
                        <div v-if="tipo_pregunta == 'res_uni'" class="mt-1 pt-1">
                          <v-radio-group class="mr-2 mt-2 pt-0" v-model="radioButtonRstpaUnica[i]"
                            @change="radioButtonCorrecto($event, i, true)">
                            <v-radio style="margin-top: -2px" :value="i"> </v-radio>
                          </v-radio-group>
                        </div>
                        <!-- RESPUESTA MULTIPLE -->
                        <div v-if="tipo_pregunta == 'res_mul'" class="mt-1 pt-1">
                          <!-- @click.native="checkBoxCorrecto" -->
                          <v-checkbox @change="checkBoxCorrecto($event, i)" v-model="checkboxesRespuestas[i]"
                            :ripple="true" style="margin: 2px 10px" hide-details></v-checkbox>
                        </div>
                        <!-- RESPUESTA V o F -->
                        <div v-if="tipo_pregunta == 'ver_fal'" class="mt-1 pt-1">
                          <v-radio-group class="mr-2 mt-2 pt-0" v-model="radioButtonRstpaUnica[i]"
                            @change="radioButtonCorrecto($event, i, true)">
                            <v-radio style="margin-top: -2px" :value="i"> </v-radio>
                          </v-radio-group>
                          <!-- <v-btn-toggle
                            style="margin-top: -2px"
                            v-model="vf_value[i]"
                            
                            group
                            @change="vf_change($event, i)"
                          >
                            <v-btn value="V"> <strong>V</strong> </v-btn>

                            <v-btn value="F"> <strong>F</strong> </v-btn>
                          </v-btn-toggle> -->
                        </div>

                        <v-btn @click="editarRespuesta(i)" class="ma-2"
                          :disabled="tipo_pregunta == 'ver_fal' ? true : false" text icon color="grey darken-4">
                          <v-icon> mdi-square-edit-outline</v-icon>
                        </v-btn>
                        <v-btn @click="eliminarRespuesta(i)" :disabled="tipo_pregunta == 'ver_fal' ? true : false"
                          class="ma-2" text icon color="grey darken-4">
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>

        <!-- <v-btn @click="testmostrar" depressed color="warning" small>
          test
        </v-btn> -->

        <v-col cols="12" class="text-center" v-if="btnguardar">
          <v-btn :loading="loadingbtnGuardar" :disabled="loadingbtnGuardar" color="primary" class="ma-2 white--text"
            @click="guardarPreguntaDB">
            {{ btnguardarTitle }}
            <v-icon right dark> mdi-database </v-icon>
          </v-btn>

          <!-- <v-btn @click="was" depressed color="primary" small> ver </v-btn> -->
        </v-col>
      </v-row>
      <!-- </v-expand-transition> -->

      <!-- CONTANEDOR 4 (VISTA SIMULADOR DE PREGUNTAS) -->
      <!-- <v-expand-transition> -->
      <v-row v-if="contenedor4">
        <v-col cols="12" align-self="center">
          <v-btn @click="changeView('contenedor2', idclase, objetoReplicaTemas)" small depressed color="error">
            <v-icon size="12"> mdi-arrow-left </v-icon> Volver
          </v-btn>
        </v-col>

        <v-col cols="12" class="pb-0">
          <v-alert color="primary" dark class="">
            <div style="text-align: center">
              <h2>{{ tituloBalotario }}</h2>
            </div>
          </v-alert>
        </v-col>

        <v-col cols="12">
          <template>
            <v-card class="bg">
              <v-row class="pt-3">
                <v-col cols="2" class="text-center">
                  <v-btn color="success" :disabled="step === 1" depressed @click="prevpageSimulador">
                    Anterior
                  </v-btn>
                </v-col>

                <v-col cols="8" class="text-center align-self-center">
                  <v-progress-linear disabled v-model="cantPreguntas" height="20" rounded>
                    <strong>{{ Math.ceil(cantPreguntas) }}%</strong>
                  </v-progress-linear>
                </v-col>

                <v-col cols="2" class="text-center">
                  <v-btn color="primary" depressed :disabled="step === contadorPreguntas" @click="nextpageSimulador">
                    Siguiente
                  </v-btn>
                </v-col>
              </v-row>

              <v-window v-model="step">
                <v-window-item v-for="(respta, i) in arrayPreguntasYrespuestas" :value="i + 1" :key="i">
                  <v-card-text class="pt-8">
                    <v-row>
                      <v-col cols="8" offset="2" class="pb-0">
                        <div class="pb-0 text-center">
                          <p class="pt-2 mb-0" v-html="respta.pregunta"></p>

                          <!-- <h2 class="text-center">
    
                                {{ respta.pregunta }}
    
                              </h2> -->
                        </div>
                      </v-col>

                      <v-col cols="8" offset="2" class="py-0">
                        <v-radio-group v-model="radioGroup">
                          <!-- :color="resptar.valor_respuesta == 'true'?'green':'blue'" -->

                          <v-alert v-for="(resptar, n) of respta.respuestas" :key="n" v-model="alertRespuestas"
                            :color="resptar.valor_respuesta ? 'green' : '#0000000'" elevation="5" dense border="left">
                            <v-row align="center">
                              <v-col class="grow">
                                <v-radio :dark="resptar.valor_respuesta ? true : false"
                                  :value="resptar.valor_respuesta ? 1 : 0">

                                  <template v-slot:label>
                                    <div style="padding:10px" v-html="resptar.valor_respuesta
                                      ? resptar.respuesta
                                      : resptar.respuesta"></div>
                                  </template>

                                </v-radio>
                              </v-col>
                              <v-col v-if="resptar.valor_respuesta" class="shrink">
                                <div class="d-flex">
                                  <div style="width: max-content; color: white;">
                                    {{ resptar.valor_respuesta ? '(Respuesta correcta)' : '' }} &nbsp;
                                  </div>

                                  <v-icon color="white">fas fa-check</v-icon>

                                </div>

                              </v-col>
                            </v-row>
                          </v-alert>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-window-item>
              </v-window>

              <v-card-actions> </v-card-actions>
            </v-card>

            <br /><br />
          </template>
        </v-col>
      </v-row>
      <!-- </v-expand-transition> -->

      <!-- COMPONENTES EXTRAS -->
      <template>
        <div class="text-center ma-2">
          <v-snackbar v-model="snackbarAlerta" :timeout="timeout" top>
            <v-icon left>mdi-check</v-icon>

            {{ Alertatext }}

            <template v-slot:action="{ attrs }">
              <v-btn color="pink" text v-bind="attrs" @click="snackbarAlerta = false">
                Close
              </v-btn>
            </template>
          </v-snackbar>

          <!-- SNACKBAR DE MODIFICACION DE ORDENES -->
          <v-snackbar :color="colorsnackbarOrden" v-model="snackbarOrden" :timeout="timeout" top>
            {{ textAlertOrden }}

            <template v-slot:action="{ attrs }">
              <v-btn color="black" text v-bind="attrs" @click="snackbarOrden = false">
                Cerrar
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
// import axios, mapActions, mapGetters { API_URL } from "@/helpers/axios";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import axios from '@/helpers/axios';
import { mapState, mapMutations } from 'vuex';
import Sortable from 'sortablejs';
import moment from 'moment';

import AutocompleteComp from '@/components/ComponentsEst/AutocompleteComp.vue';

export default {
  name: 'Simulador',
  components: {
    // ckeditor: CKEditor.component,
    alertaMensaje: () => import('../components/Co-alertaMensaje.vue'),
    ResetButton: () => import('../components/Co-resetBtn.vue'),
    confirmButton: () => import('../components/Co-ComfirMensaje.vue'),
    AutocompleteComp
  },
  data: () => ({
    isLayoutReady: false,
    editorConfig: {
      extraPlugins: 'ckeditor_wiris',
      embed_provider: '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',
      mathJaxLib: '//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
      protectedSource: [/<u[^>]><\/u>/g],
      disallowedContent: 'script; *[on*]; *[style*]',
      allowedContent: true,
      extraAllowedContent: 'math[xmlns]; maction; maligngroup; malignmark; menclose; merror; mfenced; mfrac; mglyph; mi;' +
        'mlabeledtr; mlogdiv; mmultiscripts; mn; mo; mover; mpadded; mphantom; mroot; mrow; ms; mscarries; mscarry;' +
        'msgroup; mstack; msline; mspace; msqrt; msrow; mstack; mstyle; msub; msup; msubsup; mtable; mtd; mtext; mtr;' +
        'munder; munderover; semantics; annotation; annotation-xml;',
      toolbar: [
        ['ckeditor_wiris_formulaEditor', 'ckeditor_wiris_formulaEditorChemistry'],
        ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates'],
        ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
        ['Find', 'Replace', '-', 'SelectAll', 'RemoveFormat'],
        ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'],
        ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'],
        ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
        ['Link', 'Unlink', 'Anchor'],
        ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'],
        ['Styles', 'Format', 'Font', 'FontSize'],
        ['TextColor', 'BGColor']
      ],

    },
    editorConfigRspta: {
      toolbar: [
        ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates'],
        ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
        ['Find', 'Replace', '-', 'SelectAll', 'RemoveFormat'],
        ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'],
        ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'],
        ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
        ['Link', 'Unlink', 'Anchor'],
        ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'],
        ['Styles', 'Format', 'Font', 'FontSize'],
        ['TextColor', 'BGColor']
      ],
      enterMode: 'div',
      shiftEnterMode: 'div',
    },
    correctoUnique: [],
    paginationData: {},
    page: 1,
    pageCount: 0,
    siezPerPage: 10,
    itemsPerPage: [5, 10, 15],
    // Variables de alerta
    mostrarSnackbar: false,
    mensajeAlerta: '',
    dialog_delete: false,
    // Variable de AlertConfim
    mostrarDialogConfirm: false,
    validaDialogConfirm: false,
    mensajeDialog: '',
    btnguardarTitle: 'Guardar',
    idpreguntaValida: null,
    ordenPregunta: null,
    tituloClase: '',
    totalPag: null,
    snackbarOrden: false,
    colorsnackbarOrden: 'green',
    textAlertOrden: '',
    //validaciones
    rul: {
      required: value => !!value || 'Campo Requerido',
      inputReq: value => !!value || 'Campo Requerido',
      selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
      email: value =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        'El correo Electrónico es incorrecto',
      min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
      min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
      min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
      max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
      max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
      max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
      max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
      max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
      max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
      max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
      max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
      max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',

      email_null: value => {
        if (value == '') {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || 'El correo Electrónico es incorrecto';
        }
      }
    },
    // ALERT SIMULADOR
    alertRespuestas: '',
    btnguardar: false,
    snackbarAlerta: false,
    Alertatext: '',
    timeout: 2000,
    // V MODEL SELECT DISABLED
    objetoReplicaTemas: [],
    idtema: '',
    select_nivel: '',
    select_grado: '',
    select_area: '',
    select_curso: '',

    // CHECKBOX DIFICULTAD DE PREGUNTA
    radioButtonRstpaUnica: [],
    // radioButtonRstpaUnica: null,
    vf_value: [],
    // VISTA 4  - IMPLEMENTA TUS PREGUNTAS
    doingPregunta: false,
    preguntaHecha: false,
    btnAgregaPregunta: false,
    btnAgregaRespuesta: false,
    // VISTA 4  - IMPLEMENTA TUS RESPUESTAS
    respuestaHecha: false,
    textarea_respuesta: '',
    idrespuestaIndex: '',
    doingRespuesta: false,
    tituloBotonAgregaEdita: 'Agrega respuestas',
    estadoAgregaEdita: 0, //0 agrega 1 edita
    // ATRIBUTOS PARA GUARDAR EN DB
    descbalotario: '',
    tipo_pregunta: 'res_uni',
    textarea_pregunta: '',
    textarea_pregunta2: '',
    dificultadCheckbox: '1',
    idclase: null,
    coleccionRespuestas: [],
    objetoDetalleRespuesta: [],
    // V MODEL DE SELECTS
    obtenerNivel: '',
    obtenerIdPais: '',
    obtenerArea: '',
    obtenerCurso: '',
    obtenerGrado: '',
    // ARRAY DATA SELECTORES
    itemsPaises: [],
    itemsNiveles: [],
    itemsAreas: [],
    itemsCursos: [],
    itemsGrados: [],
    // DISABLED PROPERTIES SELECTORES
    disabledNivel: true,
    disabledGrado: true,
    disabledArea: true,
    disabledCurso: true,
    // PARAMETROS PARA CONSULTA FILTRO DE TEMAS
    paramsTemas: {
      id_pais: '',
      id_nivel: '',
      id_grado: '',
      id_area: '',
      id_curso: '',
      id_tema: ''
    },
    rptaDisabled: false,
    // BUSCADORES PROPIEDADES
    searchQtPreguntas: '',
    searchPreguntas: '',
    // VARIABLES Y PARAMETROS DL SIMULADOR VISTA
    tituloBalotario: 'Tema',
    search: null,
    cantPreguntas: 0,
    contadorPreguntas: null,
    step: 1,
    radioGroup: 1,
    titleCreation: 'Filtrar preguntas', //POR USAR AUN
    nombre_unidad: '',
    // CONTENEDOR GLOBAL DE SELECTORES PARA REUZAR COMPONENTE
    contenedor_selectores: true,
    contenedor0: true,
    contenedor1: false,
    contenedor2: false,
    contenedor3: false,
    contenedor4: false,
    // LOADERS
    loading: [],
    loadingtemas: false,
    loadingbtnGuardar: false,
    // SELECTOR Y TITULO - TIPO PREGUNTAS
    itemTiposPreguntas: [
      { text: 'Respuesta única', value: 'res_uni' },
      { text: 'Respuesta múltiple', value: 'res_mul' },
      { text: 'Verdadero o falso', value: 'ver_fal' }
    ],
    // VISTA PRINCIPAL DATATABLE - BANCO DE PREGUNTAS
    arraydataUnidad: [],
    headersPrincipal: [
      { text: 'UNIDAD', value: 'unidad', class: 'secondary black--text' },
      { text: 'TEMA', value: 'tema', class: 'secondary black--text' },
      {
        text: 'CANTIDAD DE PREGUNTAS',
        value: 'cantidad',
        class: 'secondary black--text'
      },
      { text: 'FECHA', value: 'fecha', class: 'secondary black--text' },
      {
        text: 'VISUALIZAR',
        value: 'accion_ver',
        sortable: false,
        class: 'secondary black--text'
      }
      // { text: "EDITAR", value: "accion_editar", sortable: false, class: "secondary black--text" },
    ],
    // VISTA CONTENEDOR 2 DATATABLE - LISTA DE TEMAS
    vis_tema: [],
    headersUnidad: [
      { text: 'GRADO', value: 'desc_grado', groupable: false },
      { text: 'UNIDAD', value: 'nombre_tema', groupable: 'agrupar' },
      { text: 'TEMA', value: 'nombre_clase', groupable: false },
      {
        text: 'CREAR PREGUNTAS',
        value: 'accion_preguntar',
        sortable: false,
        groupable: false
      },
      {
        text: 'VER PREGUNTAS',
        value: 'accion_ver',
        sortable: false,
        groupable: false
      }
    ],
    expanded: [],
    toogleG: true,
    exLoading: false,
    itemsPerPageTemas: 10, // Opciones de cantidad de elementos por página
    footerProps: {
      itemsPerPageOptions: [5, 10, 15, 30]
    },
    readyloadTemas: false,
    // VISTA CONTENEDOR 3
    arrayPreguntasClase: [],
    headerPregunta: [
      { text: 'ID', value: 'idpregunta', sortable: false },
      { text: 'TÍTULO', value: 'titulo', sortable: false },
      { text: 'DIFICULTAD', value: 'dificultad', sortable: false },
      { text: 'ORDEN', value: 'orden', sortable: false },
      { text: 'TIPO', value: 'tipo', sortable: false },
      { text: 'EDITAR', value: 'ver', sortable: false }
    ],
    arrayPreguntasYrespuestas: [],
    arrayRespuestasPorPreguntas: [],
    arrayBalotarioDeleted: [], //Array de id Balotario
    arrayPreguntaDeleted: [], //Array de id Preguntas
    coloresValidos: [],
    checkboxesRespuestas: [],
    color: 'error',
    datoLogin: sessionStorage
  }),
  mounted() {
    this.initialize();
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations('mensajeSis', ['setEnviarMens']),

    //////////FUNCIÓN PARA FORMATEAR LAS FECHA DIA MES AÑO /////////////////////////////////////
    formatearFecha(fecha) {
      return moment(fecha).format('DD-MM-YY');
    },

    hideSnackbar(e) {
      this.mostrarSnackbar = e;
    },

    /*----------------------------------*/
    /* DELETE - DEACTIVATE BALOTARIO ID */
    /*----------------------------------*/
    async eliminarBalotarioDeactivate() {
      const me = this;
      try {
        if (me.arrayBalotarioDeleted.length != 0) {
          const response = await axios.put(
            '/simulador/simuladorExamen/simuladorBalotarios/simuladorB/changestate',
            {
              arrayidbalotario: me.arrayBalotarioDeleted
            }
          );

          me.listarPreguntasAgrupadas();

          // me.snackbarOrden = true;
          // me.colorsnackbarOrden = "red";
          // me.textAlertOrden = response.data.message;
          let tipo = response.data.success === 'Sucess' ? 'S' : 'E';
          this.setEnviarMens({
            tipo,
            mensaje: response.data.message,
            tiempo: null
          });
        } else {
          me.setEnviarMens({
            tipo: 'W',
            mensaje: 'No seleccionó ninguna fila',
            tiempo: null
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        me.arrayBalotarioDeleted.splice(0); //Vaciar el array de seleccionados para evitar eventualidades
      }
    },

    /*---------------------------------*/
    /* DELETE - DEACTIVATE PREGUNTA ID */
    /*---------------------------------*/
    async confirmDelete(e) {
      const me = this;

      me.validaDialogConfirm = e;

      if (e == true) {
        try {
          const response = await axios.put(
            '/simulador/simuladorExamen/simuladorPreguntas/simuladorP/changestatepregunta/',
            {
              arrayidpregunta: me.arrayPreguntaDeleted
            }
          );
          me.dialog_delete = false; //Se cierra el modal grande
          me.mostrarDialogConfirm = false;
          me.listarPreguntasPorClases(me.idclase);

          let tipo = response.data.success === 'Sucess' ? 'S' : 'E';
          me.setEnviarMens({
            tipo,
            mensaje: response.data.message,
            tiempo: null
          });

          // me.mostrarSnackbar = true;
          // me.mensajeAlerta = response.data.message;
          // me.listarPreguntasAgrupadas();
        } catch (error) {
          me.mostrarDialogConfirm = false;
          console.log(error);
        } finally {
          me.arrayPreguntaDeleted.splice(0); //vaciar array para no generar conflicto
        }
      }
    },

    /*---------------------------------*/
    /* DELETE - DEACTIVATE PREGUNTA ID */
    /*---------------------------------*/
    async eliminarPreguntaDeactivate() {
      const me = this;
      console.log({ arrayPreguntaDeleted: me.arrayPreguntaDeleted });
      if (me.arrayPreguntaDeleted.length > 0) {
        me.dialog_delete = true; //SE ABRE EL MODAL ANTIGUO
        // me.mostrarDialogConfirm = true;
      } else {
        // ---------------------------
        this.setEnviarMens({
          tipo: 'W',
          mensaje: 'No seleccionó ninguna fila',
          tiempo: null
        });
      }
    },

    /*-------------------------*/
    /* SELECCIONA UNO PREGUNTA */
    /*-------------------------*/
    seleccionIndividualPregunta(event, item) {
      // , isSelected, select
      const me = this;
      if (event === true) {
        me.arrayPreguntaDeleted.push(item.idpregunta);
      } else {
        let index = me.arrayPreguntaDeleted.indexOf(item.idpregunta);

        if (index !== -1) {
          me.arrayPreguntaDeleted.splice(index, 1);
        }
      }
    },

    /*--------------------------*/
    /* SELECCIONA UNO BALOTARIO */
    /*--------------------------*/
    seleccionIndividual(event, item) {
      // , isSelected, select
      const me = this;
      if (event === true) {
        me.arrayBalotarioDeleted.push(item.idbalotario);
      } else {
        let index = me.arrayBalotarioDeleted.indexOf(item.idbalotario);

        if (index !== -1) {
          me.arrayBalotarioDeleted.splice(index, 1);
        }
      }
    },

    /*------------------*/
    /* SELECCIONA TODOS */
    /*------------------*/
    // COMENTADO PORQUE NO SE USA
    // was() {
    //   console.log(this.objetoDetalleRespuesta);
    // },

    /*------------------*/
    /* SELECCIONA TODOS */
    /*------------------*/
    selecionaTodos(event) {
      const me = this;
      if (event.value == true) {
        me.arrayBalotarioDeleted = [];
        let arrayitems = event.items;
        arrayitems.forEach(element => {
          me.arrayBalotarioDeleted.push(element.idbalotario);
        });
      } else {
        me.arrayBalotarioDeleted = [];
      }
    },

    /*----------------------------*/
    /* SELECCIONA PREGUNTAS TODOS */
    /*----------------------------*/
    selecionaTodosPregunta(event) {
      const me = this;
      if (event.value == true) {
        me.arrayPreguntaDeleted = [];
        let arrayitems = event.items;
        arrayitems.forEach(element => {
          me.arrayPreguntaDeleted.push(element.idpregunta);
        });
      } else {
        me.arrayPreguntaDeleted = [];
      }
    },

    /*-------------------*/
    /* SELECCIONA PAISES */
    /*-------------------*/
    async selectorPaises(idpais) {
      const me = this;
      me.paramsTemas.id_pais = idpais;
      me.paramsTemas.id_nivel = '';
      me.paramsTemas.id_grado = '';
      me.paramsTemas.id_area = '';
      me.paramsTemas.id_curso = '';
      me.itemsNiveles = [];
      me.itemsGrados = [];
      me.itemsAreas = [];
      me.itemsCursos = [];

      try {
        const response = await axios.get(`/manager/nivelCkOne/pais/${idpais}`);
        me.itemsNiveles = response.data;

        me.obtenerArea = '';
        me.obtenerCurso = '';

        if (me.contenedor1 == true) {
          me.listarTemas();
        }

        me.listarPreguntasAgrupadas();
        if (me.itemsNiveles.length > 0) {
          me.disabledNivel = false;
          me.disabledArea = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    /*--------------------*/
    /* SELECCIONA NIVELES */
    /*--------------------*/
    async selectorNiveles(id) {
      const me = this;
      me.paramsTemas.id_nivel = id;
      me.paramsTemas.id_grado = '';
      me.paramsTemas.id_area = '';
      me.paramsTemas.id_curso = '';
      me.itemsGrados = [];
      me.itemsAreas = [];
      me.itemsCursos = [];

      try {
        const response = await axios.get('/manager/gradoCkOne/grados/' + id + '');
        me.itemsGrados = response.data;
        me.obtenerArea = '';
        me.obtenerCurso = '';
        if (me.contenedor1 == true) {
          me.listarTemas();
        }
        me.listarPreguntasAgrupadas();
        if (me.itemsGrados.length > 0) {
          me.disabledGrado = false;
          me.disabledArea = true;
          me.disabledCurso = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    /*-------------------*/
    /* SELECCIONA GRADOS */
    /*-------------------*/
    async selectorGrados(id) {
      const me = this;
      me.paramsTemas.id_area = '';
      me.paramsTemas.id_curso = '';
      me.paramsTemas.id_grado = id;
      me.itemsAreas = [];
      me.itemsCursos = [];
      me.obtenerCurso = null;
      me.obtenerArea = null;
      me.disabledCurso = true;

      try {
        const response = await axios.get(`/manager/areaCkOne/nivel/${me.obtenerNivel}`);
        me.itemsAreas = response.data;
        if (me.contenedor1 == true) {
          me.listarTemas();
        }
        me.listarPreguntasAgrupadas();
        if (me.itemsAreas.length > 0) {
          me.disabledArea = false;
        } else {
          me.disabledArea = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    /*------------------*/
    /* SELECCIONA AREAS */
    /*------------------*/
    async selectorAreas(id) {
      const me = this;
      me.paramsTemas.id_curso = '';
      me.paramsTemas.id_area = id;
      me.itemsCursos = [];

      let params = {
        id_area: id,
        id_grado: me.paramsTemas.id_grado,
        id_pais: me.paramsTemas.id_pais
      };
      try {
        const response = await axios.post('/manager/cursoCkOne/cursos/', params);
        me.itemsCursos = response.data;

        if (me.itemsCursos.length > 0) {
          me.disabledCurso = false;
        } else {
          me.disabledCurso = true;
        }
        if (me.contenedor1 == true) {
          me.listarTemas();
        }
        me.listarPreguntasAgrupadas();
      } catch (e) {
        console.log(e);
      }
    },

    /*-------------------*/
    /* SELECCIONA CURSOS */
    /*-------------------*/
    async selectorCursos(id) {
      const me = this;
      me.paramsTemas.id_curso = id;
      if (me.contenedor1 == true) {
        me.listarTemas();
      }
      me.listarPreguntasAgrupadas();
    },

    /*---------------------------*/
    /* LIMPIAR SELECTS Y VMODELS */
    /*---------------------------*/
    vaciarSelects() {
      const me = this;
      me.disabledNivel = true;
      me.disabledGrado = true;
      me.disabledArea = true;
      me.disabledCurso = true;
      me.itemsPaises = [];
      me.itemsNiveles = [];
      me.itemsGrados = [];
      me.itemsAreas = [];
      me.itemsCursos = [];
      me.obtenerNivel = '4';
      me.obtenerGrado = '';
      me.obtenerArea = '';
      me.obtenerCurso = '';
      me.obtenerIdPais = '';
      me.paramsTemas.id_pais = '';
      me.paramsTemas.id_grado = '';
      me.paramsTemas.id_area = '';
      me.paramsTemas.id_curso = '';
      me.paramsTemas.id_tema = '';
    },

    /*----------------*/
    /* LIMPIAR CAMPOS */
    /*----------------*/
    limpiarCampos() {
      const me = this;
      me.descbalotario = '';
      me.rptaDisabled = false;
      me.tipo_pregunta = 'res_uni';
      me.textarea_pregunta = '';
      me.dificultadCheckbox = '0';
      me.coleccionRespuestas = [];
      me.objetoDetalleRespuesta = [];
      me.doingPregunta = true;
      me.doingRespuesta = true;
      me.preguntaHecha = false;
    },

    colapsarGrupo() {
      const me = this;
      Object.keys(me.$refs.table.openCache).forEach(g => {
        me.$refs.table.openCache[g] = false;
      });
    },

    actualizarVtable(pagination) {
      console.log('Nueva cantidad de elementos por página:', pagination.itemsPerPage);
      setTimeout(() => {
        this.colapsarGrupo();
      }, 1000);
    },

    /*-----------------------------------------------------------------------*/
    /*  ---------- VISTA FORMULARIO CREAR PREGUNTA Y RESPUESTAS -------------*/
    /*-----------------------------------------------------------------------*/
    /*------------------------------------------*/
    /* SELECTOR BUTTON V/F RESPUESTAS CORRECTAS */
    /*------------------------------------------*/
    vf_change(value, i) {
      // console.log(value);
      const me = this;
      if (me.vf_value[i] == 'V') {
        me.coloresValidos[i] = 'success';
      } else {
        me.coloresValidos[i] = 'error';
      }
    },

    /*----------------------------------------*/
    /* SELECTOR CHECKBOX RESPUESTAS CORRECTAS */
    /*----------------------------------------*/
    checkBoxCorrecto(checked, i) {
      const me = this;

      // console.log(me.objetoDetalleRespuesta[i].valor_respuesta);
      // console.log(i);

      if (checked) {
        me.coloresValidos[i] = 'success';
        me.objetoDetalleRespuesta[i].valor_respuesta = true;
      } else {
        me.coloresValidos[i] = 'error';
        me.objetoDetalleRespuesta[i].valor_respuesta = false;
      }
    },

    /*------------------------------------------------------------*/
    /* SELECTOR RADIOBUTTON RESPUESTAS CORRECTAS RESPUESTA UNICA  */
    /*------------------------------------------------------------*/
    radioButtonCorrecto(checked, i, flag) {
      const me = this;
      me.radioButtonRstpaUnica = [];
      me.radioButtonRstpaUnica[i] = checked;

      me.objetoDetalleRespuesta[i].valor_respuesta = [];
      for (let o = 0; o < me.objetoDetalleRespuesta.length; o++) {
        if (i == o) {
          me.objetoDetalleRespuesta[o].valor_respuesta = flag;
        } else {
          me.objetoDetalleRespuesta[o].valor_respuesta = false;
        }
      }

      me.coloresValidos = [];
      me.coloresValidos[checked] = 'success';
    },

    /*-----------------------------*/
    /* SELECTOR TIPO DE RESPUESTAS */
    /*-----------------------------*/
    cambiarTipoRespuesta(valor) {
      const me = this;

      me.radioButtonRstpaUnica = [];
      me.coleccionRespuestas = [];
      me.objetoDetalleRespuesta = [];
      me.doingRespuesta = true;

      // console.log(valor);
      me.coloresValidos = [];
      me.checkboxesRespuestas = [];
      me.vf_value = [];

      if (valor == 'ver_fal') {
        me.doingRespuesta = false;
        me.rptaDisabled = true;

        let VerdaderFalso = ['VERDADERO', 'FALSO'];

        const idpregunta =
          me.idpreguntaValida == '' && me.idpreguntaValida == null ? '' : me.idpreguntaValida;

        for (let i = 0; i < VerdaderFalso.length; i++) {
          me.objetoDetalleRespuesta.push({
            valor_respuesta: false,
            descripcion: VerdaderFalso[i],
            orden: 0,
            idpregunta: idpregunta,
            estado: true
          });

          me.coleccionRespuestas.push(VerdaderFalso[i]);
        }
      } else {
        me.coleccionRespuestas = [];
        me.rptaDisabled = false;
      }
    },

    /*---------------------*/
    /* CAMBIAR VISTA DE UI */
    /*---------------------*/
    changeView(string, id, objeto) {
      const me = this;

      switch (string) {
        case 'contenedor0':
          me.titleCreation = 'BANCO DE PREGUNTAS';
          me.resetSelects();
          me.listarPais();
          me.contenedor_selectores = true;
          me.contenedor0 = true;
          me.contenedor1 = false;
          me.contenedor2 = false;
          me.contenedor3 = false;
          me.contenedor4 = false;
          break;

        case 'contenedor1':
          me.loadingtemas = true;
          me.listarTemas();
          me.idclase = '';
          me.titleCreation = 'FILTRAR TEMAS';
          me.vaciarSelects();
          me.listarPais();
          setTimeout(() => {
            me.contenedor_selectores = true;
            me.contenedor1 = true;
            me.contenedor0 = false;
            me.contenedor2 = false;
            me.contenedor3 = false;
            me.contenedor4 = false;
            this.loadingtemas = false;
          }, 2000);
          // me.paramsTemas.id_nivel = "4";
          break;

        case 'contenedor2':
          me.objetoReplicaTemas = objeto;
          me.idclase = objeto.id_clase || objeto.id || '';
          me.listarPreguntasPorClases(me.idclase);
          me.limpiarCampos();
          // POBLAR LOS CAMPOS MEDIANTE CONDICIONES
          me.nombre_unidad = objeto.nombre_clase || objeto.tema || '';
          me.select_nivel = objeto.desc_nivel || '';
          me.select_grado = objeto.desc_grado || '';
          me.select_area = objeto.desc_area || '';
          me.select_curso = objeto.desc_curso || '';

          me.titleCreation = 'PREGUNTAS POR TEMA';
          me.contenedor2 = true;
          me.arrayPreguntasYrespuestas.splice(0, me.arrayPreguntasYrespuestas.length);
          me.contenedor_selectores = false;
          me.contenedor0 = false;
          me.contenedor1 = false;
          me.contenedor3 = false;
          me.contenedor4 = false;

          me.cantPreguntas = 0;
          me.contadorPreguntas = null;
          me.totalPag = null;
          me.coloresValidos = [];
          me.radioButtonRstpaUnica = [];
          break;
        // CREAR O EDITAR PREGUNTA
        case 'contenedor3':
          me.loading = [];
          // console.log(objeto);
          me.tituloClase = me.objetoReplicaTemas.tema || me.objetoReplicaTemas.nombre_clase;
          me.select_nivel = me.objetoReplicaTemas.desc_nivel || '';
          me.select_grado = me.objetoReplicaTemas.desc_grado || '';
          me.select_area = me.objetoReplicaTemas.desc_area || '';
          me.select_curso = me.objetoReplicaTemas.desc_curso || '';

          if (objeto != null) {
            //CUANDO SE EDITARA O SE ACTUALIZA LA PREGUNTA Y SUS RESPUESTA
            // alert("entrando a actualizar");
            me.loading[objeto.idpregunta] = true; //loading del boton
            // console.log(objeto);
            me.btnguardar = true;
            me.btnguardarTitle = 'Editar';
            me.preguntaHecha = true;
            me.doingPregunta = false;
            me.textarea_pregunta = objeto.titulo;
            me.textarea_pregunta2 = objeto.titulo;
            // Atributos para editar en DB
            me.ordenPregunta = objeto.orden;
            me.idpreguntaValida = objeto.idpregunta;
            me.tipo_pregunta = objeto.tipo;
            me.doingRespuesta = false;
            switch (objeto.tipo) {
              case 'ver_fal':
                me.doingRespuesta = false;
                me.rptaDisabled = true;
                break;

              case 'res_uni':
                me.doingRespuesta = true;
                me.rptaDisabled = false;
                break;

              case 'res_mul':
                me.doingRespuesta = true;
                me.rptaDisabled = false;
                break;
            }

            me.dificultadCheckbox = objeto.dificultad.toString();
            me.listarRespuestaPorPregunta(objeto);
          } else {
            me.idpreguntaValida = null;
            me.contenedor3 = true;
            me.titleCreation = 'GENERAR PREGUNTAS Y RESPUESTAS';
            me.contenedor_selectores = false;
            me.contenedor0 = false;
            me.contenedor1 = false;
            me.contenedor2 = false;
            me.contenedor4 = false;

            me.btnguardarTitle = 'Guardar';
            me.btnguardar = false;
          }

          break;
        // VER SIMULADOR
        case 'contenedor4':
          me.arrayPreguntasYrespuestas = [];
          me.listarPreguntaRespuestasDetalleClase(me.idclase || id);

          break;
      }
    },

    /*--------------------------------------------*/
    /* FUNCION NUEVA LINEA EN TEXTAREA RESPUESTAS */
    /*--------------------------------------------*/
    nuevaLineaTxArea() {
      const me = this;
      me.value = `${me.value}\n`;
    },

    /*------------------------------*/
    /* ABRIR TEXTAREA PARA PREGUNTA */
    /*------------------------------*/
    abrirTextareaPregunta() {

      const me = this;

      if (me.doingPregunta && me.textarea_pregunta == '') {
        alert('Por favor redacte una pregunta.');
        return;
      }

      me.doingPregunta = !me.doingPregunta;
      if (me.doingPregunta) {
        me.preguntaHecha = false;

        setTimeout(() => {
          this.textarea_pregunta = this.textarea_pregunta2;
        }, 1000);


      } else {

        this.textarea_pregunta2 = this.textarea_pregunta
        me.preguntaHecha = true;
      }
    },

    checkFormulaRendered(callback) {
      this.$nextTick(() => {
        const editor = this.$refs.editor.$el.querySelector('.cke_editor');
        if (editor) {
          editor.addEventListener('change', () => {
            const content = editor.getData();
            if (content.includes('<math')) { // Verifica si la fórmula está renderizada
              console.log('La fórmula ha sido renderizada.');
              if (callback && typeof callback === 'function') {
                callback();  // Llama al callback cuando la fórmula esté lista
              }
            }
          });
        } else {
          console.log("El editor de CKEditor no está disponible.");
        }
      });
    },

    /*-----------------------------------*/
    /* VISUALIZAR ELEMENTOS DE RESPUESTA */
    /*-----------------------------------*/
    abrirTextareaRespuesta() {
      const me = this;

      if (!me.preguntaHecha) {
        me.snackbarOrden = true;
        me.colorsnackbarOrden = 'red';
        me.textAlertOrden = 'Ingresa una Pregunta previamente';

        return false;
      }

      me.doingRespuesta = !me.doingRespuesta;

      if (me.doingRespuesta == true) {
        me.respuestaHecha = false;
      } else {
        me.respuestaHecha = true;
      }
    },

    /*-------------------*/
    /* AGREGAR RESPUESTA */
    /*-------------------*/
    agregarRespuesta(rpsta) {
      const me = this;

      if (me.textarea_respuesta != '') {
        me.textarea_respuesta = '';
        me.respuestaHecha = true;
        me.$refs.textareaResp.focus();

        if (me.estadoAgregaEdita == 1) {
          //CUANDO EDITA O ACTUALIZA RESPUESTAS

          me.coleccionRespuestas[me.idrespuestaIndex] = rpsta;
          me.objetoDetalleRespuesta[me.idrespuestaIndex].descripcion = rpsta; //Nuevo Valor en Objeto a Editar
          me.estadoAgregaEdita = 0;
          me.tituloBotonAgregaEdita = 'Agrega respuesta';
          // me.btnAgregaRespuesta();
          // me.$refs.textareaResp.select();
        } else {
          //CUANDO REGISTRA O CREA RESPUESTAS

          const idpregunta =
            me.idpreguntaValida == '' && me.idpreguntaValida == null ? '' : me.idpreguntaValida;

          const objtCrea = {
            valor_respuesta: false,
            descripcion: rpsta,
            orden: 0,
            idpregunta: idpregunta,
            estado: true
          };
          me.objetoDetalleRespuesta.push(objtCrea);
          me.coleccionRespuestas.push(rpsta);
        }

        // me.hideBotones();
      } else {
        alert('Escribe una respuesta');
        return false;
      }
    },

    /*------------------*/
    /* EDITAR RESPUESTA */
    /*------------------*/
    editarRespuesta(i) {
      const me = this;

      me.idrespuestaIndex = i;
      me.tituloBotonAgregaEdita = 'Edita respuesta';
      me.estadoAgregaEdita = 1;
      me.textarea_respuesta = me.coleccionRespuestas[i]; //+ 'indice '+ i
    },

    /*--------------------*/
    /* ELIMINAR RESPUESTA */
    /*--------------------*/
    eliminarRespuesta(i) {
      const me = this;
      me.coleccionRespuestas.splice(i, 1);
      me.objetoDetalleRespuesta.splice(i, 1);
      me.coloresValidos.splice(i, 1);
      // CHECKBOX UNICO, MULTIPLE, VERDADERO Y FALSO.
      me.vf_value.splice(i, 1);
      me.checkboxesRespuestas.splice(i, 1);
      me.radioButtonRstpaUnica.splice(i, 1);
      // me.radioButtonRstpaUnica[i] = i;

      let indexFind = me.coloresValidos.indexOf('success');
      me.radioButtonRstpaUnica[indexFind] = indexFind;

      // me.hideBotones();
    },

    /*-------------------------*/
    /* AÑADE PREGUNTA EN VISTA */
    /*-------------------------*/
    agregaPreguntaVista() {
      const me = this;
      me.doingPregunta = false;
      me.preguntaHecha = true;
      me.doingRespuesta = true;
      // me.$refs.textareaResp.focus();
    },

    /*------------------------------*/
    /* VALIDAR PREGUNTA EN TEXTAREA */
    /*------------------------------*/
    validaTextAreaPregunta() {
      const me = this;
      if (me.textarea_pregunta == '') {
        me.btnAgregaPregunta = false;
      } else {
        me.btnAgregaPregunta = true;
      }
    },

    /*-------------------------------*/
    /* VALIDAR RESPUESTA EN TEXTAREA */
    /*-------------------------------*/
    validaTextAreaRespuesta() {
      const me = this;
      if (me.textarea_respuesta == '') {
        me.btnAgregaRespuesta = false;
      } else {
        me.btnAgregaRespuesta = true;
      }
    },



    /*------------------------*/
    /* GUARDAR PREGUNTA EN DB */
    /*------------------------*/
    async guardarPreguntaDB() {
      const me = this;

      // const hasTrueValue = me.objetoDetalleRespuesta.some(
      //   (obj) => Object.values(obj)[0] === true
      // );

      // if (!hasTrueValue) {
      //   alert("Por favor Selecciona una respuesta");
      //   return false;
      // }



      if (me.doingPregunta == true) {
        alert('Por favor agrega la pregunta');
        return false;
      }

      // CREAR PREGUNTA Y RESPUETAS
      if (me.idpreguntaValida == '' || me.idpreguntaValida == null) {
        try {
          NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
          NProgress.start();
          me.loadingbtnGuardar = true;
          const respuesta = await axios.post(
            '/simulador/simuladorExamen/simuladorPreguntas/simuladorP/registra',
            {
              descripcion_balotario: 'BALOTARIO' + me.idclase,
              descripcion: me.textarea_pregunta,
              tipo_pregunta: me.tipo_pregunta,
              orden: me.arrayPreguntasClase.length + 1,
              nivel: me.dificultadCheckbox,
              idtema: me.idclase,
              respuestas: me.objetoDetalleRespuesta
            }
          );
          if (respuesta.status == '200') {
            NProgress.done();
            me.changeView('contenedor2', me.idclase, me.objetoReplicaTemas);
            me.loadingbtnGuardar = false;
            me.btnAgregaPregunta = false;
            me.btnguardar = false;
            me.mostrarSnackbar = true;
            me.mensajeAlerta = 'Pregunta registrada satisfactoriamente';
            me.idpreguntaValida == '';
            // me.setEnviarMens({ tipo: 'S', mensaje: `Pregunta registrada satisfactoriamente`, tiempo: null })
          }
        } catch (error) {
          console.log(error);
        }
        // EDITAR PREGUNTA Y RESPUETAS
      } else {
        try {
          NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
          NProgress.start();
          me.loadingbtnGuardar = true;
          const respuesta = await axios.put(
            '/simulador/simuladorExamen/simuladorPreguntas/simuladorP/actualiza/' +
            me.idpreguntaValida,
            {
              descripcion_balotario: 'BALOTARIO' + me.idclase,
              descripcion: me.textarea_pregunta,
              tipo_pregunta: me.tipo_pregunta,
              orden: me.ordenPregunta,
              nivel: me.dificultadCheckbox,
              idtema: me.idclase,
              respuestas: me.objetoDetalleRespuesta
            }
          );

          if (respuesta.status == '200') {
            NProgress.done();
            me.changeView('contenedor2', me.idclase, me.objetoReplicaTemas);
            me.loadingbtnGuardar = false;
            me.btnAgregaPregunta = false;
            me.btnguardar = false;
            // me.setEnviarMens({ tipo: 'S', mensaje: `Pregunta actualizada satisfactoriamente`, tiempo: null })
            me.mostrarSnackbar = true;
            me.mensajeAlerta = 'Pregunta actualizada satisfactoriamente';
            me.idpreguntaValida == '';
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    /*---------------*/
    /* LISTAR PAISES */
    /*---------------*/
    async listarPais() {
      const me = this;
      me.itemsPaises = [];
      try {
        let response = await axios.get('/manager/pais/');
        me.itemsPaises = response.data;

        // console.log(response.data);
      } catch (error) {
        console.log(error);
      }
    },

    /*--------------------------*/
    /* LISTAR TEMAS POR FILTROS */
    /*--------------------------*/
    async listarTemas() {
      const me = this;
      me.readyloadTemas = true;
      me.vis_tema = [];
      try {
        await axios
          .post(
            '/simulador/simuladorExamen/simuladorPreguntas/simuladorP/listaClasesManager',
            me.paramsTemas
          )
          .then(({ data }) => {
            // console.log(data.Clases);

            me.vis_tema = data.Clases;
            me.readyloadTemas = false;

            setTimeout(() => {
              me.colapsarGrupo();
            }, 1000);
          });
      } catch (error) {
        console.log(error);
      }
    },

    /*----------------------------*/
    /* LISTAR TODAS LAS PREGUNTAS */
    /*----------------------------*/
    async listarPreguntasAgrupadas() {
      const me = this;
      try {
        NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
        NProgress.start();

        const response = await axios.post(
          '/simulador/simuladorExamen/simuladorPreguntas/simuladorP/listaAgrupada/',
          me.paramsTemas
        );
        me.arraydataUnidad = response.data;
        NProgress.done();
      } catch (error) {
        console.log(error);
      }
    },

    /*----------------------------------------*/
    /* LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    /*----------------------------------------*/
    async listarPreguntaRespuestasDetalleClase(idclase) {
      const me = this;
      try {
        const response = await axios.get(
          '/simulador/simuladorExamen/simuladorRespuestas/simuladorR/listares/' + idclase
        );

        if (response.data.length == 0) {
          me.snackbarOrden = true;
          me.colorsnackbarOrden = 'red';
          me.textAlertOrden = 'NO TIENES BALOTARIO PARA ESTA CLASE';
        } else {
          me.titleCreation = 'Simulador de examenes';
          me.tituloBalotario = 'Tema: ' + me.nombre_unidad;
          me.contenedor4 = true;
          me.contenedor_selectores = false;
          me.contenedor0 = false;
          me.contenedor1 = false;
          me.contenedor2 = false;
          me.contenedor3 = false;

          let map = new Map();
          response.data.forEach(currentValue => {
            map.has(currentValue.pregunta)
              ? map.get(currentValue.pregunta).push({
                estado: currentValue.estado,
                idpregunta: currentValue.idpregunta,
                idrespuesta: currentValue.idrespuesta,
                idtema: currentValue.idtema,
                orden: currentValue.orden,
                respuesta: currentValue.respuesta,
                valor_respuesta: currentValue.valor_respuesta
              })
              : map.set(currentValue.pregunta, [
                {
                  estado: currentValue.estado,
                  idpregunta: currentValue.idpregunta,
                  idrespuesta: currentValue.idrespuesta,
                  idtema: currentValue.idtema,
                  orden: currentValue.orden,
                  respuesta: currentValue.respuesta,
                  valor_respuesta: currentValue.valor_respuesta
                }
              ]);
          });

          const arr = Array.from(map, ([pregunta, respuestas]) => {
            // return { [key]: value };
            return { pregunta, respuestas };
          });

          me.arrayPreguntasYrespuestas = arr;
          let contadorPag = arr.length;
          me.contadorPreguntas = contadorPag;
          me.totalPag = 100 / contadorPag;
          // me.cantPreguntas = me.totalPag;
        }
      } catch (error) {
        console.log(error);
      }
    },

    /*----------------------------------------*/
    /* LISTAR PREGUNTAS Y RESPUETAS POR CLASE */
    /*----------------------------------------*/
    async listarRespuestaPorPregunta(items) {
      const me = this;
      NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
      NProgress.start();

      try {
        const response = await axios.get(
          '/simulador/simuladorExamen/simuladorRespuestas/simuladorR/listarespreg/' +
          items.idpregunta
        );
        // me.doingRespuesta = true;
        // me.respuestaHecha = true;
        me.textarea_respuesta = '';
        me.arrayRespuestasPorPreguntas = response.data;

        // if (response.data.length != 0) {

        setTimeout(async () => {
          NProgress.done();
          me.titleCreation = 'GENERAR PREGUNTAS Y RESPUESTAS';
          me.contenedor3 = true;
          me.contenedor_selectores = false;
          me.contenedor0 = false;
          me.contenedor1 = false;
          me.contenedor2 = false;
          me.contenedor4 = false;
          me.tituloClase = me.objetoReplicaTemas.tema;
          me.loading[items.idpregunta] = false;
        }, 800);
        // }else{
        //   alert('no hay ')
        // }

        me.arrayRespuestasPorPreguntas.forEach((element, index) => {
          me.coleccionRespuestas.push(element.respuesta);
          const objtEdita = {
            idrespuesta: element.idrespuesta,
            valor_respuesta: element.valor_respuesta,
            descripcion: element.respuesta,
            orden: 0,
            idpregunta: items.idpregunta,
            estado: true
          };
          me.objetoDetalleRespuesta.push(objtEdita);

          // console.log(items.tipo);

          switch (items.tipo) {
            case 'res_uni':
              if (objtEdita.valor_respuesta) {
                me.radioButtonRstpaUnica[index] = index;
                me.coloresValidos[index] = 'success';
              }
              break;

            case 'res_mul':
              if (objtEdita.valor_respuesta) {
                me.checkboxesRespuestas[index] = objtEdita.valor_respuesta;
                me.coloresValidos[index] = 'success';
              }

              break;

            case 'ver_fal':
              if (objtEdita.valor_respuesta) {
                me.radioButtonRstpaUnica[index] = index;
                me.coloresValidos[index] = 'success';
              }
              break;

            default:
              break;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    /*----------------------------*/
    /* LISTAR TODAS LAS PREGUNTAS */
    /*----------------------------*/
    async listarPreguntasPorClases(idclase) {
      const me = this;

      try {
        const response = await axios.get(
          '/simulador/simuladorExamen/simuladorPreguntas/simuladorP/lista/' + idclase
        );
        me.arrayPreguntasClase = response.data;

        // console.log(response.data);
      } catch (error) {
        console.log(error);
      }
    },

    /*------------------------------------------*/
    /* METODO PARA OBTENER OBJETO DE PAGINACION */
    /*------------------------------------------*/
    getPagination(pagination) {
      const me = this;
      me.paginationData = pagination;
    },
    /*---------------------------------------*/
    /* METODO PARA USAR DRAG Y CAMBIAR ORDEN */
    /*---------------------------------------*/
    cambiarOrden(event, idtema) {
      const me = this;
      const ordenNew = event.newIndex + me.paginationData.pageStart + 1;
      const movedItem = me.arrayPreguntasClase.splice(
        event.oldIndex + me.paginationData.pageStart,
        1
      )[0];
      me.arrayPreguntasClase.splice(event.newIndex + me.paginationData.pageStart, 0, movedItem);
      me.arrayPreguntasClase[event.newIndex + me.paginationData.pageStart].orden = ordenNew;

      for (let i = 0; i < event.target.children.length; i++) {
        // console.log(event.target.children[i].children[1].innerText);
        // console.log(me.paginationData.pageStart + i + 1);
        me.modificarOrdenPreguntas(
          idtema,
          event.target.children[i].children[1].innerText,
          me.paginationData.pageStart + i + 1
        );
        let numit = Number(me.paginationData.pageStart + i + 1 - 1);
        // console.log(numit);
        me.arrayPreguntasClase[numit].orden = me.paginationData.pageStart + i + 1;
      }

      me.mostrarSnackbar = true;
      me.mensajeAlerta = 'Orden Cambiado';
      // me.setEnviarMens({ tipo: 'S', mensaje: `Orden Cambiado`, tiempo: null })
    },

    /*-------------------------------*/
    /* METODO PARA ORDENAR PREGUNTAS */
    /*-------------------------------*/
    async modificarOrdenPreguntas(idtema, idpregunta, newIndex) {
      // const me = this;
      try {
        await axios.put(
          '/simulador/simuladorExamen/simuladorPreguntas/simuladorP/actualizaIndice/' + idtema,
          {
            orden_new: newIndex,
            idpregunta: idpregunta
          }
        );
      } catch (error) {
        console.log(error);
      }
    },

    /*------------------------------*/
    /* METODO NEXT SIMULADOR WIZZAR */
    /*------------------------------*/
    nextpageSimulador() {
      const me = this;
      console.log({ totalPag: me.totalPag, step: me.step });

      if (me.totalPag == 100) {
        // SI YA ESTÁ AL 100 NO HACER NADA AL LLAMAR AL EVENTO o
        me.cantPreguntas = me.totalPag * me.step;
        return;
      }
      if (me.totalPag == 1) {
        //  solo es una pregunta (1)
        me.cantPreguntas = me.totalPag * me.step;
        return;
      }
      me.step++;

      me.cantPreguntas = me.totalPag * me.step;
    },

    /*------------------------------*/
    /* METODO PREV SIMULADOR WIZZAR */
    /*------------------------------*/
    prevpageSimulador() {
      const me = this;
      me.step--;

      if (me.step == 1) {
        // SI YA ESTÁ EN LA PRIMERA PÁGINA
        me.cantPreguntas = me.totalPag * 0;
      } else {
        me.cantPreguntas = me.totalPag * me.step;
      }
    },

    /*-------------------------------*/
    /* METODO RESET SELECTS Y LISTAR */
    /*-------------------------------*/
    async resetSelects() {
      const me = this;
      me.paramsTemas.id_pais = '';
      me.paramsTemas.id_nivel = '';
      me.paramsTemas.id_grado = '';
      me.paramsTemas.id_area = '';
      me.paramsTemas.id_curso = '';
      me.paramsTemas.id_tema = '';
      me.vaciarSelects();
      me.initialize();
    },

    /*------------------*/
    /* METODO DE INICIO */
    /*------------------*/
    async initialize() {
      const me = this;

      me.$store.commit('mostrarLoading', {
        titulo: 'Cargando lista de temas',
        color: '#fff',
        colorDialog: '#212121',
        ancho: 300
      });

      await me.listarPais();
      await me.listarPreguntasAgrupadas();
      await me.$store.commit('ocultarLoading');
    },

    //
    handleKeydown(event) {
      const me = this;
      switch (event.key) {
        case 'ArrowRight':
          me.nextpageSimulador();
          break;
        case 'ArrowLeft':
          me.prevpageSimulador();
          break;
      }
    }
  },
  directives: {
    sortable: {
      bind(el, binding, vnode) {
        const options = {
          animation: 150,
          onUpdate: function (event) {
            vnode.child.$emit('sorted', event);
          }
        };
        Sortable.create(el.getElementsByTagName('tbody')[0], options);
      }
    }
  },
  watch: {
    coleccionRespuestas(e) {
      if (e.length != 0) {
        this.btnguardar = true;
      } else {
        this.btnguardar = false;
      }
    }
  },
  computed: {
    ...mapState(['loadingSpiner', 'loginPerfil'])
  }
};
</script>
<!----------------------------------
| ESTILOS GLOBALES PARA COMPONENTE |
----------------------------------->
<style scoped>
.classEditor {
  display: flex;
  justify-content: space-around;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.bg {
  min-height: 430px;
  width: 100%;
  height: 100%;
  background: url('https://static.vecteezy.com/system/resources/previews/007/588/881/non_2x/white-grey-gradient-abstract-background-with-soft-glowing-backdrop-background-texture-for-design-free-photo.jpg');
}

.hidden {
  display: none;
}

/* div.cke_notifications_area {
  display: none;
} */
</style>

<style>
.cke_button__ckeditor_wiris_formulaeditor .cke_button_icon {
  background-image: url('/ckeditor/icons/formula.png') !important;
}

.cke_button__ckeditor_wiris_formulaeditorchemistry .cke_button_icon {
  background-image: url('/ckeditor/icons/chem.png') !important;

}
</style>
